<template>
    <header class="header">
        <div class="logo">
            <a href="/">
                <img src="./assets/img/green-x-logo-black.png" alt="green-">
            </a>
            <div class="nav">
                <div class="nav-menu" :class="{'isActive': route.name === 'home'}">
                    <router-link :to='`/${lan}`'>{{ $t('首页') }}</router-link>
                </div>
                <div class="nav-menu" :class="{'isActive': route.name === 'notice'}">
                    <router-link :to='`/${lan}/notice`' >{{ $t('公告') }}</router-link>
                </div>
                <div class="nav-menu" :class="{'isActive': route.name === 'project'}">
                    <router-link :to='`/${lan}/project`' >{{ $t('RWA数字股票') }}</router-link>
                </div>
            </div>
        </div>
        <div class="lang">
            <div class="language-container">
                <svg class="language-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.23 20.403a9.011 9.011 0 005.684-7.153h-3.942c-.147 2.86-.793 5.388-1.741 7.153zm-.757-7.153c-.178 4.102-1.217 7.25-2.473 7.25-1.256 0-2.295-3.148-2.473-7.25h4.946zm0-2.5H9.527C9.705 6.648 10.744 3.5 12 3.5c1.256 0 2.295 3.148 2.473 7.25zm2.499 0h3.942a9.01 9.01 0 00-5.683-7.153c.948 1.765 1.594 4.293 1.741 7.153zm-9.936 0c.147-2.862.793-5.392 1.743-7.156a9.01 9.01 0 00-5.693 7.156h3.95zm0 2.5h-3.95a9.01 9.01 0 005.693 7.157c-.95-1.765-1.596-4.295-1.743-7.157z" fill="currentColor"></path></svg>
                <div class="lang-list">
                    <p @click="selectLang(item.lang)" v-for="(item,index) in langList" :key="index">{{ item.title }}</p>
                </div>
            </div>
        </div>
    </header>
    <header class="header-h5">
        <div class="header-h5-container" @mouseleave="isSelect = false">
            <div class="logo">
                <a href="/">
                    <img src="./assets/img/green-x-logo-black.png" alt="green-">
                </a>
            </div>

            <div class="spread" @click="isSelect = !isSelect" :class="{'isSelect': isSelect}">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="select" v-show="isSelect">
                <div class="nav">
                    <router-link :to='`/${lan}`' :class="{'isActive': route.name === 'home'}" @click="isSelect = false">{{ $t('首页') }}</router-link>
                    <router-link :to='`/${lan}/notice`' :class="{'isActive': route.name === 'notice'}" @click="isSelect = false">{{ $t('公告') }}</router-link>
                    <router-link :to='`/${lan}/project`' :class="{'isActive': route.name === 'project'}" @click="isSelect = false">{{ $t('RWA数字股票') }}</router-link>
                    <div class="lang-h5">
                        <div class="language-container">
                            <div class="svg-h5">
                                <svg class="language-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.23 20.403a9.011 9.011 0 005.684-7.153h-3.942c-.147 2.86-.793 5.388-1.741 7.153zm-.757-7.153c-.178 4.102-1.217 7.25-2.473 7.25-1.256 0-2.295-3.148-2.473-7.25h4.946zm0-2.5H9.527C9.705 6.648 10.744 3.5 12 3.5c1.256 0 2.295 3.148 2.473 7.25zm2.499 0h3.942a9.01 9.01 0 00-5.683-7.153c.948 1.765 1.594 4.293 1.741 7.153zm-9.936 0c.147-2.862.793-5.392 1.743-7.156a9.01 9.01 0 00-5.693 7.156h3.95zm0 2.5h-3.95a9.01 9.01 0 005.693 7.157c-.95-1.765-1.596-4.295-1.743-7.157z" fill="currentColor"></path></svg>
                                {{ $t('语言') }}
                            </div>
                            <div class="lang-list">
                                <p @click="selectLang(item.lang)" v-for="(item,index) in langList" :class="{'isSelect': item.lang === lan}" :key="index">{{ item.title }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </header>
    <router-view/>
</template>

<script setup lang="ts">
import {reactive, watch, ref} from "vue";
import { useRoute, useRouter} from 'vue-router';
const route = useRoute();
const router = useRouter();

const lan = ref();
const isSelect = ref<boolean>(false);
const langList = reactive([
    {
        lang: 'zh_CN',
        title: '简体中文'
    },
    {
        lang: 'en_US',
        title: 'English'
    },
    {
        lang: 'ko_KR',
        title: '한국어'
    },
    {
        lang: 'ja_JP',
        title: '日本語'
    },
    {
        lang: 'id_ID',
        title: 'Bahasa'
    },
])


watch(() => route.path, () => {
    lan.value = localStorage.getItem('lang');
    const l:any = route.params.lang;
    // 监听路由路径变化
    if (l !== lan.value) {
        localStorage.setItem('lang', l);
        reloadPage();
    }
});
const selectLang = (lang: string) => {
    isSelect.value = false;
    router.push({
        params: {
            lang
        }
    });
}

const reloadPage = () => {
   window.location.reload();
}

</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
    height: 100%;
    width: 100%;
}
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.06);
}
.logo {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    img {
        height: 50px;
        width: 100px;
    }
    .nav {
        display: flex;
        margin-left: 15px;
        height: 100%;
        align-items: center;
        .nav-menu {
            height: 100%;
            font-size: 16px;
            font-weight: 500;
            padding: 0 15px;
            display: flex;
            align-items: center;

            &.isActive {
                border-bottom: 2px solid #19bca0;
                a {
                    color: #19bca0;
                }

            }
        }
    }
}
.lang {
    height: 100%;
    .language-container {
        position: relative;
        height: 60px;
        display: flex;
        align-items: center;
        &:hover {
            .lang-list {
                display: block;
                z-index: 100;
            }
        }

        .language-icon {
            width: 24px;
            margin-right: 20px;
            cursor: pointer;
        }
        .lang-list {
            position: absolute;
            top: 60px;
            right: 5px;
            min-width: 80px;
            padding: 5px 10px;
            background-color: #fff;
            box-shadow: 4px 4px 4px 4px rgba(0, 0, 0, 0.06);
            display: none;
            p {
                cursor: pointer;
                padding: 5px 0 ;
                &:hover {
                    color: #19bca0;
                }
            }
        }
    }
   
}
@media screen and (max-width: 900px) {
    .header {
        display: none;
    }
    .header-h5 {
        display: block;
    }
}
@media screen and (min-width: 900px) {
    .header {
        display: flex;
    }
    .header-h5 {
        display: none;
    }
}
.header-h5 {
    background-color: #fff;
    .header-h5-container {
        display: flex;
        justify-content: space-between;
        box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.06);
        position: relative;
    }
    .spread {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        span {
            width: 30px;
            height: 2px;
            background-color: #000;
            margin-bottom: 6px;
        }
        &.isSelect {
            span {
                &:first-child {
                    transform: rotate(45deg);
                }
                &:nth-child(2) {
                    opacity: 0;
                }
                &:last-child {
                    transform: rotate(-45deg);
                    margin-top: -16px;
                }
            }
        }
    }

    .select {
        width: 100%;
        position: absolute;
        background-color: #fff;
        top: 60px;
        z-index: 2;
        padding: 10px 15px;
        color: #202630;
        .nav {
            font-size: 16px;
            display: flex;
            flex-direction: column;
            a {
                padding: 5px 0;
                &:hover {
                    color: #19bca0;
                    background-color: rgba(25,188,160,0.3);
                }
                &.isActive {
                    color: #19bca0;
                }
            }
        }
        .lang-h5 {
            display: flex;
            .language-container {
                width: 100%;

                .svg-h5 {
                    display: flex;
                    align-items: center;
                }
                .language-icon {
                    width: 18px;
                }
                .lang-list {
                    margin-top: 5px;
                    p {
                        padding: 3px 0 3px 15px;
                        font-size: 14px;
                        &:hover {
                            background-color: rgba(25,188,160,0.3);
                            color: #19bca0;
                        }
                        &.isSelect {
                            color: #19bca0;
                        }
                    }
                }
            }
        }
    }
}
</style>
